import React from 'react';

import FeedList from './components/FeedList';
import Feed from './components/FeedContainer';
import FeedActionBar from './components/FeedActionBar';
import { ActivityFeedContainer } from './styles';

const ActivityFeed = () => (
  <ActivityFeedContainer data-testid="activity-feed">
    <FeedList />
    <Feed />
    <FeedActionBar />
  </ActivityFeedContainer>
);

export default ActivityFeed;
